import moment from 'moment'
import {
    getVehicleAndChartDateSummaryColumns,
    getWithHamaliAndCartageSummaryColumn,
    getVehicleWithDispatchSummaryColumn,
    headerColumnChallanWiseDispatchSummaryColumn,
    withVehicleANdChartCol,
    withVehicleANdChartColTwo,
    withPaymentTypeColWithFormat,
    withPaymentTypeCol,
    coloumnDispatchDetails11,
    coloumnDispatchDetails12,
    coloumnDispatchDetails1WithFormatLR,
    coloumnDispatchDetails2,
    showOnlyToPayCol,
    showOnlyToPayColTwo,
    showOnlyToPayColWithFormat,
    showOnlyToPayColWithFormatTwo,
    showOnlyToPayAmountSummaryColumn
} from '../common/reportConstants'

import { divideInNIntegers, formatNumber } from '../../../../components/common/mathHelper'
import { getWithOtherChargesColumn } from './Constant'
import { getInt } from '../../../common/helper'
import { GUJRAT_COMPANY_ID, GAJRAJ } from '../../../../helper/companyIdhardcode'

const round = (num) => Number(num.toFixed(2))
const alignment = ['left', 'center', 'right']

export const buildDispatchCriteriaHeaders = () => [
    { field: 'fromDate', header: 'From Dispatch Date', textAlign: 'left' },
    { field: 'toDate', header: 'To Dispatch Date', textAlign: 'left' },
    { field: 'dispatchBranch', header: 'Dispatch By Branch', textAlign: 'left' },
    { field: 'destCity', header: 'Destination City', textAlign: 'left' },
    { field: 'destBranch', header: 'Destination Branch', textAlign: 'left' },
    { field: 'vehicleNo', header: 'Vehicle Number', textAlign: 'left' },
    { field: 'paymentType', header: 'Payment Type', textAlign: 'left' },
    { field: 'reportType', header: 'Report Type', textAlign: 'left' },
    { field: 'reportView', header: 'Report View', textAlign: 'left' },
    { field: 'reportOption', header: 'Report Option', textAlign: 'left' },
]

export const buildDispatchCriteriaData = ({
    fromDate, toDate, selFromBranch, selDestCity,
    selBranch, selVehicle, selPaymentTpe,
    reportType, showSummaryReport, detailedFilter, loginData
}) => ({
    fromDate: moment(fromDate).format('DD-MM-YYYY'),
    toDate: moment(toDate).format('DD-MM-YYYY'),
    dispatchBranch: selFromBranch?.name || loginData?.strBranchName,
    destCity: selDestCity?.name || 'All',
    destBranch: selBranch?.name || 'All',
    vehicleNo: selVehicle?.name || 'All',
    paymentType: selPaymentTpe?.name || 'All',
    reportType: reportType?.Name,
    reportView: showSummaryReport?.Name,
    reportOption: detailedFilter?.Name,
    dataType: 'entry',
})

export const buildSection5MainHeader = (loginCountryId, UseToPayAsCOD) => {
    const columns = getVehicleAndChartDateSummaryColumns(loginCountryId, UseToPayAsCOD)
    const textFields = ['VehicleNo', 'UniqueTripNames', 'UniqueTripIDs', 'UniqueChartDate']
    return columns.map((col) => ({
        field: col.field,
        header: col.headerName,
        exportHead: col.exportHead,
        align: textFields.includes(col.field) ? 'left' : 'right',
        xlCol: col.xlCol,
        weight: 40,
        dataType: 'header',
        isSortIcon: col.isSortIcon,
    }))
}

export const buildSection6MainHeader = (loginCountryId, UseToPayAsCOD) => {
    const columns = getWithHamaliAndCartageSummaryColumn(loginCountryId, UseToPayAsCOD)
    const textFields = ['SN', 'BusNumber', 'DriverConductorName^^ContactNo', 'Station']
    return columns.map((col) => ({
        field: col.field,
        header: col.headerName,
        exportHead: col.exportHead,
        align: textFields.includes(col.field) ? 'left' : 'right',
        xlCol: col.xlCol,
        weight: 40,
        dataType: 'header',
        isSortIcon: col.isSortIcon,
    }))
}
export const buildChallanWiseDispatchMainHeader = () => {
    const textFields = ['SN', 'ToCity', 'FromTo', 'ItemDetails', 'DispatchDate']
    return headerColumnChallanWiseDispatchSummaryColumn.map((col) => ({
        field: col.field,
        header: col.headerName,
        exportHead: col.exportHead,
        align: textFields.includes(col.field) ? 'left' : 'right',
        xlCol: col.xlCol,
        weight: col?.weight ?? 50,
        isSortIcon: col.isSortIcon,
    }))
}

export const buildDetailedVWCMainHeader = (loginCountryId, UseToPayAsCOD, intCompanyID) => {
    const columns = (loginCountryId !== 2 ? withVehicleANdChartCol : withVehicleANdChartColTwo)
    const textFields = ['VehicleNo', 'SummaryFromCity', 'SummaryToCity', 'DispatchDateTime', 'SummaryDriverConductorName']

    const mainHeader = columns
        .map((col) => ({
            ...col,
            field: col.field,
            header: col.header,
            exportHead: col.pdfHead || col.header,
            align: textFields.includes(col.field) ? 'left' : 'right',
            xlCol: col.xlCol,
            weight: col.weight || 40,
            dataType: 'header',
            isMandatory: intCompanyID === GUJRAT_COMPANY_ID ? false : col.isMandatory,
        }))

    return UseToPayAsCOD === 1
        ? mainHeader.map((col) => {
            if (col.field === 'topayCount') return { ...col, header: 'COD\nLRs', exportHead: 'COD\nLRs' }
            if (col.field === 'totalToPayCodFreight') return { ...col, header: 'COD\nFreight', exportHead: 'COD\nFreight' }
            if (col.field === 'totalToPayCodGstOther') return { ...col, header: 'COD\nGST+Oth', exportHead: 'COD\nGST+Oth' }
            return col
        })
        : mainHeader
}

export const buildVehicleWiseDispatchDetailedMainHeader = (loginCountryId, allownFormatLR, reportTypeId, intCompanyID) => {
    let columns
    if (reportTypeId === 1) {
        columns = coloumnDispatchDetails2
    } else if (allownFormatLR === 3) {
        columns = coloumnDispatchDetails1WithFormatLR
    } else {
        columns = loginCountryId === 2 ? coloumnDispatchDetails12 : coloumnDispatchDetails11
    }

    const textFields = ['SN', 'OnlyLRNo', 'LRNO', 'FormattedLRNO', 'VoucherNo',
        'DispTimeAndDate', 'BookingDateTime', 'BookCity', 'DestCityBranch',
        'DispatchedToCityFilter', 'PickupCity', 'SenderName', 'RecName',
        'ItemDetails', 'PaymentType', 'VehicleNo']

    return columns
        .filter(col => !col.isHeader && !col.isSummaryHeader)
        .map(col => ({
            field: col.field,
            header: col.header,
            exportHead: col.pdfHead || col.header,
            align: textFields.includes(col.field) ? 'left' : 'right',
            xlCol: col.xlCol,
            weight: col.weight || 40,
            width: getInt(col.headerSx.minWidth) || 50,
            // isSelected: col.isSelected,
            isSelected: col.field === 'Remarks' && intCompanyID === GAJRAJ ? true : col.isSelected,
            isDefault: col.isDefault,
            // isMandatory: intCompanyID === GUJRAT_COMPANY_ID ? false : col.isMandatory,
            isMandatory: intCompanyID === GUJRAT_COMPANY_ID ? false : col.field === 'Remarks' && intCompanyID === GAJRAJ ? true : col.isMandatory,
            id: col.id,
            isSortIcon: col.isSortIcon,
        }))
}

export const buildShowOnlyToPayMainHeader = (loginCountryId, allownFormatLR, UseToPayAsCOD, intCompanyID) => {
    let columns
    if (allownFormatLR === 3) {
        columns = loginCountryId !== 2 ? showOnlyToPayColWithFormat : showOnlyToPayColWithFormatTwo
    } else {
        columns = loginCountryId !== 2 ? showOnlyToPayCol : showOnlyToPayColTwo
    }

    if (UseToPayAsCOD === 1) {
        columns = columns
            .map(col => {
                if (col.field === '2') return { ...col, header: 'COD' }
                if (col.field === '7') return { ...col, header: 'COD (Manual)' }
                if (col.field === '9') return { ...col, header: 'COD (DDDV)' }
                return col
            })
            .filter(col => col.field !== '4')
    }

    const textFields = ['OnlyLRNo', 'LRNO', 'ManualLR', 'FormattedLRNO',
        'SenderName', 'SenderGSTN', 'RecName', 'ReceiverGSTN',
        'ItemDetails', 'PaymentType', 'Remarks']

    return columns
        .filter(col => !col.isHeader && !col.isSummaryHeader)
        .map(col => ({
            field: col.field,
            header: col.header,
            exportHead: col.pdfHead || col.header,
            align: textFields.includes(col.field) ? 'left' : 'right',
            xlCol: col.xlCol,
            weight: 40,
            isSelected: col.isSelected,
            isDefault: col.isDefault,
            isMandatory: intCompanyID === GUJRAT_COMPANY_ID ? false : col.isMandatory,
            id: col.id,
            isSortIcon: col.isSortIcon,
        }))
}

export const buildShowOnlyToPaySummaryHeader = (UseToPayAsCOD) => {
    let columns = showOnlyToPayAmountSummaryColumn
    if (UseToPayAsCOD === 1) {
        columns = columns
            .map(col => {
                if (col.field === 'toPayQuantity') return { ...col, headerName: 'COD \nUnit', exportHead: 'COD\nUnit' }
                if (col.field === 'toPayAmount') return { ...col, headerName: 'COD \nAmt.', exportHead: 'COD\nAmt.' }
                if (col.field === 'toPay(Manual)Quantity') return { ...col, headerName: 'COD (Manual) \nUnit', exportHead: 'COD (Manual)\nUnit' }
                if (col.field === 'toPay(Manual)Amount') return { ...col, headerName: 'COD (Manual) \nAmt.', exportHead: 'COD (Manual)\nAmt.' }
                if (col.field === 'toPay(DDDV)Quantity') return { ...col, headerName: 'COD (DDDV) \nUnit', exportHead: 'COD (DDDV)\nUnit' }
                if (col.field === 'toPay(DDDV)Amount') return { ...col, headerName: 'COD (DDDV) \nAmt.', exportHead: 'COD (DDDV)\nAmt.' }
                return col
            })
            .filter(col => col.field !== 'cODQuantity' && col.field !== 'cODAmount')
    }

    return columns.map(col => ({
        field: col.field,
        header: col.headerName,
        exportHead: col.exportHead,
        align: col.pdfColSx?.halign,
        xlCol: col.xlCol,
        weight: 40,
        isSortIcon: col.isSortIcon,
    }))
}

export const buildPaymentTypeGroupMainHeader = (allownFormatLR = 0,intCompanyID) => {
    const columns = allownFormatLR === 3 ? withPaymentTypeColWithFormat : withPaymentTypeCol
    const textFields = ['SN',
        'LRNO^^VoucherNo^^ManualLR',
        'VehicleNoFilter',
        'DispatchDateTime', 'BookCity', 'ToCity', 'DispatchedToCityFilter',
        'DispatchedToBranchFilter',
        'SenderName^^SenderMobileNo^^SenderGSTN^^SenderEmailID',
        'RecName^^RecMobileNo^^ReceiverGSTN^^ReceiverEmailID',
        'ItemDetails']

    return columns
        .map((col) => ({
            ...col,
            field: col.field,
            header: col.header,
            exportHead: col.pdfHead || col.header,
            align: textFields.includes(col.field) ? 'left' : 'right',
            xlCol: col.xlCol,
            weight: 40,
            isMandatory: intCompanyID === GUJRAT_COMPANY_ID ? false : col.isMandatory,
        }))
}

export const transformChallanWiseDispatch = (rawTable) => {
    const data = rawTable.map((val, index) => ({
        ...val,
        dataType: 'entry',
        SN: index + 1,
        Quantity: Number(val.Quantity),
        Total: Number(val.Total),
        Less: Number(val.Less),
    }))

    const totalNOP = data.reduce((sum, row) => sum + row.Quantity, 0)
    const totalTotal = data.reduce((sum, row) => sum + row.Total, 0)
    const totalLess = data.reduce((sum, row) => sum + row.Less, 0)

    data.push({
        dataType: 'total',
        colSpan: { SN: 5 },
        align: { SN: 'left' },
        SN: 'Total',
        Quantity: totalNOP,
        Total: totalTotal,
        Less: totalLess,
    })

    return data
}

export const transformVehicleWiseDispatchDetailed = (rawTable, mainHeader) => {
    const processedData = rawTable.map(item => {
        if (item.DestCityBranch && item.DestCityBranch.includes("/\n")) {
            const [DestCity, DestBranch] = item.DestCityBranch
            return { ...item, DestCity, DestBranch }
        }
        return item
    })

    const numericFields = [
        'Quantity', 'Freight', 'DocumentCharges', 'CartageAmount',
        'HamaliCharges', 'OperatorHamaliChg', 'ServiceTaxAmount',
        'CartageTax', 'OptHamaliGST', 'Insurance', 'AllOther', 'NetAmount',
    ]

    const grouped = processedData.reduce((acc, item) => {
        const key = item.VehicleNoFilter || 'NA'
            ; (acc[key] ||= []).push(item)
        return acc
    }, {})

    const rows = []

    Object.values(grouped).forEach((group) => {
        const lengths = divideInNIntegers(mainHeader.length, 3)
        let index = 0
        const pickedHeaders = []
        for (const span of lengths) {
            if (mainHeader[index]) pickedHeaders.push(mainHeader[index].field)
            index += span
        }

        rows.push({
            dataType: 'subHeader',
            totalSubKey: 3,
            colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
            align: Object.fromEntries(pickedHeaders.map((key, i) => [key, alignment[i]])),
            [pickedHeaders[0]]: `Vehicle No.: ${group[0]?.VehicleNoFilter || 'NA'}`,
            [pickedHeaders[1]]: `Driver Name: ${group[0]?.DriverConductorName || 'NA'}`,
            [pickedHeaders[2]]: `Contact No.: ${group[0]?.ContactNo || 'NA'}`,
        })

        const totals = Object.fromEntries(numericFields.map(key => [key, 0]))

        group.forEach((obj, i) => {
            rows.push({
                ...obj,
                dataType: 'entry',
                SN: i + 1,
                CombinedLRNO: `${obj.LRNO}${obj.ManualLR ? ',\n' + obj.ManualLR : ''}`,
                BookingDateTime: `${moment(obj.BookingDateTime, 'DD-MMM-YY HH:mm A').format('DD-MMM-YY')}\n${moment(obj.BookingDateTime, 'DD-MMM-YY HH:mm A').format('HH:mm A')}`,
                DispTimeAndDate: `${moment(obj.DispatchDateTime, 'DD-MMM-YY HH:mm A').format('DD-MMM-YY')}\n${moment(obj.DispatchDateTime, 'DD-MMM-YY HH:mm A').format('HH:mm A')}`,
                OnlyLRNo: `${obj.OnlyLRNo}\n${obj.ManualLR}`,
                VoucherNo: `${obj.VoucherNo}\n${obj.PartyBillNo}`,
                BookCity: `${obj.BookCity}\n${obj.SourceBranchName}`,
                DestCityBranch: obj.DestCityBranch,
                DispatchedToCityFilter: `${obj.DispatchedToCityFilter}\n${obj.DispatchedToBranchFilter}`,
                SenderName: `${obj.SenderName}\n${obj.SenderMobileNo}\n${obj.SenderGSTN}\n${obj.SenderEmailID}`,
                RecName: `${obj.RecName}\n${obj.RecMobileNo}\n${obj.ReceiverGSTN}\n${obj.ReceiverEmailID}`,
            })
            numericFields.forEach(key => {
                const val = +obj[key]
                if (!isNaN(val)) totals[key] += val
            })
        })

        const formattedTotals = Object.fromEntries(
            Object.entries(totals).map(([k, v]) => [k, formatNumber(v)])
        )
        const nonNumericCount = mainHeader.length - numericFields.length
        rows.push({
            dataType: 'total',
            align: { [mainHeader[0].field]: 'right' },
            colSpan: { [mainHeader[0].field]: Math.max(1, nonNumericCount) },
            [mainHeader[0].field]: 'TOTAL',
            ...formattedTotals,
        })
    })

    return rows
}

export const transformVehicleWiseSummaryDetailed = (rawTable) => {
    const numericFields = [
        'Quantity', 'Freight', 'DocumentCharges', 'CartageAmount',
        'HamaliCharges', 'OperatorHamaliChg', 'ServiceTaxAmount',
        'CartageTax', 'OptHamaliGST', 'Insurance', 'NetAmount',
    ]

    const grouped = rawTable.reduce((acc, item) => {
        const key = item.PaymentTypeInt || 'NA'
            ; (acc[key] ||= []).push(item)
        return acc
    }, {})

    const rows = []

    Object.values(grouped).forEach((group) => {
        const totals = Object.fromEntries(numericFields.map(f => [f, 0]))
        group.forEach(obj => {
            numericFields.forEach(key => {
                const val = Number(obj[key])
                if (!isNaN(val)) totals[key] += val
            })
        })
        Object.keys(totals).forEach(key => {
            totals[key] = formatNumber(totals[key])
        })
        rows.push({ dataType: 'entry', PaymentType: group[0]?.PaymentType ?? 'NA', ...totals })
    })

    const grandTotals = Object.fromEntries(numericFields.map(f => [f, 0]))
    rows.forEach(row => {
        if (row.dataType !== 'entry') return
        numericFields.forEach(key => {
            const val = Number(row[key])
            if (!isNaN(val)) grandTotals[key] += val
        })
    })
    rows.push({ dataType: 'total', PaymentType: 'Total For Vehicle No', ...grandTotals })

    return rows
}

export const transformShowOnlyToPay = (rawTable, mainHeader) => {
    const grouped = rawTable.reduce((acc, item) => {
        const key = item.VehicleNo
            ; (acc[key] ||= []).push(item)
        return acc
    }, {})

    const rows = []
    let grandQty = 0
    let grandAmt = 0

    const firstField = mainHeader[0]?.field
    const qtyIndex = mainHeader.findIndex(col => col.field === 'Quantity')

    Object.entries(grouped).forEach(([vehicleNo, group]) => {
        rows.push({
            dataType: 'subHeader',
            [firstField]: `Vehicle No.: ${vehicleNo}`,
            colSpan: { [firstField]: 2 },
            align: { [firstField]: 'left' },
        })

        let groupQty = 0
        let groupAmt = 0

        group.forEach(obj => {
            const isToPay = [2, 4, 7, 9].includes(obj.PaymentTypeInt)
            const netAmt = isToPay ? Number(obj.NetAmount) : 0
            rows.push({
                ...obj,
                dataType: 'entry',
                NetAmount: netAmt,
            })
            groupQty += Number(obj.Quantity)
            if (isToPay) groupAmt += Number(obj.NetAmount)
        })

        groupQty = Number(groupQty.toFixed(2))
        groupAmt = Number(groupAmt.toFixed(2))
        grandQty += groupQty
        grandAmt += groupAmt

        rows.push({
            dataType: 'total',
            [firstField]: `Total For Vehicle No: ${vehicleNo}`,
            colSpan: { [firstField]: qtyIndex },
            align: { [firstField]: 'right' },
            Quantity: formatNumber(groupQty),
            NetAmount: formatNumber(groupAmt),
        })
    })

    rows.push({
        dataType: 'total',
        [firstField]: 'Total For ALL Vehicles',
        colSpan: { [firstField]: qtyIndex },
        align: { [firstField]: 'right' },
        Quantity: formatNumber(grandQty),
        NetAmount: formatNumber(grandAmt),
    })

    return rows
}

export const transformPaymentTypeGroup = (rawTable, mainHeader, allownFormatLR = 0) => {
    const updatedData = rawTable.map((val) => ({
        ...val,
        AllOther: round(val.AllOther + val.DocumentCharges),
        HamaliCharges: val.HamaliCharges + val.OperatorHamaliChg,
    }))

    const numericFields = ['Quantity', 'Freight', 'HamaliCharges', 'CartageAmount', 'Insurance', 'AllOther', 'NetAmount']
    const firstField = mainHeader[0]?.field
    const quantityIndex = mainHeader.findIndex(col => col.field === 'Quantity')

    const grouped = updatedData.reduce((acc, item) => {
        const key = `${item.PaymentType}-${item.IsApp}`
        if (!acc[key]) acc[key] = []
        acc[key].push(item)
        return acc
    }, {})

    const grandTotals = Object.fromEntries(numericFields.map(f => [f, 0]))
    const rows = []

    Object.values(grouped).forEach((g) => {
        const first = g[0]
        const caption = `${first.PaymentType} LRs Dispatched By ${first.IsApp == 0 ? 'CRS2011 DeskApp' : 'Maven Application'}`
        const subtotals = Object.fromEntries(numericFields.map(f => [f, 0]))

        rows.push({
            dataType: 'subHeader',
            [firstField]: caption,
            colSpan: { [firstField]: mainHeader.length },
        })

        g.forEach((obj, index) => {
            rows.push({
                ...obj,
                dataType: 'entry',
                SN: index + 1,
                'LRNO^^VoucherNo^^ManualLR': `${obj.LRNO}\n${obj.VoucherNo}\n${obj.ManualLR}`,
                'SenderName^^SenderMobileNo^^SenderGSTN^^SenderEmailID': `${obj.SenderName}\n${obj.SenderMobileNo}\n${obj.SenderGSTN}\n${obj.SenderEmailID}`,
                'RecName^^RecMobileNo^^ReceiverGSTN^^ReceiverEmailID': `${obj.RecName}\n${obj.RecMobileNo}\n${obj.ReceiverGSTN}\n${obj.ReceiverEmailID}`,
            })
            numericFields.forEach(f => {
                subtotals[f] += Number(obj[f]) || 0
                grandTotals[f] += Number(obj[f]) || 0
            })
        })

        numericFields.forEach(f => { subtotals[f] = Number(subtotals[f].toFixed(2)) })
        rows.push({
            dataType: 'total',
            [firstField]: 'TOTAL',
            colSpan: { [firstField]: quantityIndex },
            align: { [firstField]: 'right' },
            ...subtotals,
        })
    })

    numericFields.forEach(f => { grandTotals[f] = Number(grandTotals[f].toFixed(2)) })
    rows.push({
        dataType: 'total',
        [firstField]: 'GRAND TOTAL',
        colSpan: { [firstField]: quantityIndex },
        align: { [firstField]: 'right' },
        ...grandTotals,
    })

    return rows
}

export const getWithOtherChargesSummaryMainHeader = (loginCountryId, UseToPayAsCOD) => {
    const textFields = ['BusNumber^^SealNo', 'DriverConductorName^^ContactNo', 'ToCityName^^ToBranchName']
    const columns = [
        { field: 'BusNumber^^SealNo', headerName: 'Veh. No.\nSeal No.', exportHead: 'Vehicle Number\nSeal Number', xlCol: { dataType: 'string', dataFormatter: null }, isSortIcon: true, },
        { field: 'DriverConductorName^^ContactNo', headerName: 'Drvr Name\nDrvr No.', exportHead: 'Driver Name\nDriver Number', xlCol: { dataType: 'string', dataFormatter: null }, isSortIcon: true, },
        { field: 'ToCityName^^ToBranchName', headerName: 'Disp. City.\nDisp. Br.', exportHead: 'Dispatch City.\nDispatch Branch', xlCol: { dataType: 'string', dataFormatter: null }, isSortIcon: true, },
        { field: 'TopayUnit', headerName: UseToPayAsCOD === 1 ? 'COD \nUnit' : 'Topay+ \nCodUnit', exportHead: UseToPayAsCOD === 1 ? 'COD \nUnit' : 'Topay+ \nCodUnit', xlCol: { dataType: 'number', dataFormatter: null }, isSortIcon: true, },
        { field: 'PaidUnit', headerName: 'Paid \nUnit', exportHead: 'Paid \nUnit', xlCol: { dataType: 'number', dataFormatter: null }, isSortIcon: true, },
        { field: 'OnAccountUnit', headerName: 'On-Act\nUnit', exportHead: 'On-Account \nUnit', xlCol: { dataType: 'number', dataFormatter: null }, isSortIcon: true, },
        { field: 'FocAndSelfUnit', headerName: 'FOC+\nSelf Unit', exportHead: 'FOC+\nSelf Unit', xlCol: { dataType: 'number', dataFormatter: null }, isSortIcon: true, },
        { field: 'DDDVUnit', headerName: 'DDDV \nUnit', exportHead: 'DDDV \nUnit', xlCol: { dataType: 'number', dataFormatter: null }, isSortIcon: true, },
        { field: 'TotalUnits', headerName: 'NET \nUnit', exportHead: 'NET \nUnit', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { borderRight: '1px solid #ccc' }, isSortIcon: true, },
        { field: 'TopayFreight', headerName: UseToPayAsCOD === 1 ? 'COD \nFrgt.' : 'Topay+COD \nFrgt.', exportHead: UseToPayAsCOD === 1 ? 'COD \nFrgt.' : 'Topay+COD \nFreight', xlCol: { dataType: 'number', dataFormatter: null }, isSortIcon: true, },
        { field: 'PaidFreight', headerName: 'Paid \nFrgt.', exportHead: 'Paid \nFreight', xlCol: { dataType: 'number', dataFormatter: null }, isSortIcon: true, },
        { field: 'OnAccountFreight', headerName: 'On-Act \nFrgt.', exportHead: 'On-Account \nFreight', xlCol: { dataType: 'number', dataFormatter: null }, isSortIcon: true, },
        { field: 'FocAndSelfFreight', headerName: 'FOC+COD \nFrgt.', exportHead: 'FOC+COD \nFreight', xlCol: { dataType: 'number', dataFormatter: null }, isSortIcon: true, },
        { field: 'DDDVFreight', headerName: 'DDDV \nFrgt.', exportHead: 'DDDV \nFreight', xlCol: { dataType: 'number', dataFormatter: null }, isSortIcon: true, },
        { field: 'TotalFreight', headerName: 'NET \nFrgt.', exportHead: 'NET \nFreight', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { borderRight: '1px solid #ccc' }, isSortIcon: true, },
        {
            field: 'TopayCodGstOth',
            headerName: loginCountryId !== 2 ? (UseToPayAsCOD === 1 ? 'COD \nGST+OTH' : 'Topay+COD \nGST+OTH') : (UseToPayAsCOD === 1 ? 'COD \nOth.' : 'Topay+COD \nOth.'),
            exportHead: loginCountryId !== 2 ? (UseToPayAsCOD === 1 ? 'COD \nGstOth.' : 'Topay+COD \nGST+OTH') : (UseToPayAsCOD === 1 ? 'COD \nOth.' : 'TopayCod \nOth.'),
            xlCol: { dataType: 'number', dataFormatter: null }, isSortIcon: true,
        },
        { field: 'PaidGstOth', headerName: loginCountryId !== 2 ? 'Paid \nGST+OTH' : 'Paid \nOth.', exportHead: loginCountryId !== 2 ? 'Paid \nGST+OTH' : 'Paid \nOth.', xlCol: { dataType: 'number', dataFormatter: null }, isSortIcon: true, },
        { field: 'OnActGstOth', headerName: loginCountryId !== 2 ? 'On-Act \nGST+OTH' : 'OnAct \nOth.', exportHead: loginCountryId !== 2 ? 'OnAccount \nGST+OTH' : 'OnAccount \nOth.', xlCol: { dataType: 'number', dataFormatter: null }, isSortIcon: true, },
        { field: 'FOCSelfGstOth', headerName: loginCountryId !== 2 ? 'FOC+Self \nGST+OTH' : 'FOCSelf \nOth.', exportHead: loginCountryId !== 2 ? 'FOC+Self \nGST+OTH' : 'FOCSelf \nOth.', xlCol: { dataType: 'number', dataFormatter: null }, isSortIcon: true, },
        { field: 'DDDVGstOth', headerName: loginCountryId !== 2 ? 'DDDV \nGST+OTH' : 'DDDV \nOth.', exportHead: loginCountryId !== 2 ? 'DDDV \nGST+OTH' : 'DDDV \nOth.', xlCol: { dataType: 'number', dataFormatter: null }, isSortIcon: true, },
        { field: 'NetOther', headerName: loginCountryId !== 2 ? 'NET \nGST+OTH' : 'NET \nOth.', exportHead: loginCountryId !== 2 ? 'NET \nGST+OTH' : 'Net \nOth.', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { borderRight: '1px solid #ccc' }, isSortIcon: true, },
        { field: 'Insurance', headerName: loginCountryId === 2 ? 'Insu. \nChrg.' : 'Val \nChrge.', exportHead: loginCountryId === 2 ? 'Insu. \nCharge' : 'Val. \nCharge', xlCol: { dataType: 'number', dataFormatter: null }, isSortIcon: true, },
        { field: 'OtherCharge', headerName: 'Oth. \nChrge.', exportHead: 'Other \nChrg.', xlCol: { dataType: 'number', dataFormatter: null }, isSortIcon: true },
        { field: 'TotalLRCount', headerName: 'Net \nLR', exportHead: 'Net \nLR', xlCol: { dataType: 'number', dataFormatter: null }, isSortIcon: true },
        { field: 'TotalNetAmount', headerName: 'Net \nAmt.', exportHead: 'Net \nAmount', xlCol: { dataType: 'number', dataFormatter: null }, isSortIcon: true },
    ]

    return columns.map((col) => ({
        field: col.field,
        header: col.headerName,
        exportHead: col.exportHead,
        align: textFields.includes(col.field) ? 'left' : 'right',
        xlCol: col.xlCol,
        weight: 40,
        dataType: 'header',
        isSortIcon: col.isSortIcon,
        headerSx: col.headerSx || {},
    }))
}

export const getOtherChargesMainHeader = (UseToPayAsCOD) => {
    const textFields = ['srNo', 'BusNumber', 'ContactNo', 'DriverConductorName', 'SealNo', 'Station']
    return getWithOtherChargesColumn(UseToPayAsCOD).map((col) => ({
        field: col.field,
        header: col.header,
        exportHead: col.exportHead,
        align: textFields.includes(col.field) ? 'left' : 'right',
        xlCol: col.xlCol,
        weight: 40,
        isSortIcon: col.isSortIcon,
        headerSx: col.headerSx || {},
    }))
}

export const getVehicleWiseDispatchSummaryMainHeader = (UseToPayAsCOD) => {
    const textFields = ['SN', 'BusNumber^^SealNo', 'FromCityName^^FromBranchName', 'ToCityName^^ToBranchName', 'DispatchDateTime', 'DriverConductorName^^ContactNo']
    return getVehicleWithDispatchSummaryColumn(UseToPayAsCOD).map((col) => ({
        field: col.field,
        header: col.headerName,
        exportHead: col.exportHead,
        align: textFields.includes(col.field) ? 'left' : 'right',
        xlCol: col.xlCol,
        weight: 40,
        isSortIcon: col.isSortIcon,
        headerSx: col.headerSx || {},
    }))
}

export const buildStatuswiseSummaryMainHeader = () => {
    const textFields = ['SN', 'SourceBranch', 'DestBranch', 'DispatchByBranch', 'PaymentType']
    const columns = [
        { field: 'SN', header: 'S/N', exportHead: 'S/N', width: 50 },
        { field: 'SourceBranch', header: 'Source Branch', exportHead: 'Source Branch', width: 180,isSortIcon: true },
        { field: 'DestBranch', header: 'Dest. Branch', exportHead: 'Dest. Branch', width: 200, isSortIcon: true },
        { field: 'DispatchByBranch', header: 'Dispatch By Branch', exportHead: 'Dispatch By Branch', width: 180, isSortIcon: true },
        { field: 'PaymentType', header: 'Pymt Type', exportHead: 'Pymt Type', width: 110, isSortIcon: true },
        { field: 'BookedLRCount', header: 'LR Count', exportHead: 'Booked and Transfered/Dispatched LR Count', width: 95, isSortIcon: true },
        { field: 'BookedTotalUnits', header: 'Total Units', exportHead: 'Booked and Transfered/Dispatched Total Units', width: 105, isSortIcon: true },
        { field: 'BookedTotalAmount', header: 'Total Amt.', exportHead: 'Booked and Transfered/Dispatched Total Amt.', width: 115, isSortIcon: true },
        { field: 'ReceivedLRCount', header: 'LR Count', exportHead: 'Received and Transferred / Dispatched LR Count', width: 95, isSortIcon: true },
        { field: 'ReceivedTotalUnits', header: 'Total Units', exportHead: 'Received and Transferred / Dispatched Total Units', width: 105, isSortIcon: true },
        { field: 'ReceivedTotalAmount', header: 'Total Amt.', exportHead: 'Received and Transferred / Dispatched Total Amt.', width: 115, isSortIcon: true },
    ]

    return columns.map((col) => ({
        ...col,
        align: textFields.includes(col.field) ? 'left' : 'right',
        xlCol: { dataType: textFields.includes(col.field) ? 'string' : 'number', dataFormatter: null },
        weight: 40,
        // isSortIcon: false,
    }))
}

const firstValue = (row, keys, fallback = '') => {
    for (const key of keys) {
        if (row?.[key] !== undefined && row?.[key] !== null && row?.[key] !== '') {
            return row[key]
        }
    }
    return fallback
}

const normalizeBranchName = (value) => String(value || '').trim().toLowerCase()
const toNumber = (value) => Number(value) || 0
const hasAnyValue = (row, keys) => keys.some((key) => row?.[key] !== undefined && row?.[key] !== null && row?.[key] !== '')

export const transformStatuswiseSummary = (rawTable, selectedDispatchBranchName = '') => {
    const bookedLRKeys = ['BookedLRCount', 'BookedCount', 'BookedLR', 'BookedTotalLR', 'BookedTotalLRCount', 'BookingLRCount']
    const bookedUnitKeys = ['BookedTotalUnits', 'BookedUnits', 'BookedQuantity', 'BookedTotalQuantity', 'BookedQty']
    const bookedAmountKeys = ['BookedTotalAmount', 'BookedAmount', 'BookedNetAmount', 'BookedTotalNetAmount']
    const receivedLRKeys = ['ReceivedLRCount', 'ReceivedCount', 'ReceivedLR', 'ReceivedTotalLR', 'ReceivedTotalLRCount', 'CrossingLRCount']
    const receivedUnitKeys = ['ReceivedTotalUnits', 'ReceivedUnits', 'ReceivedQuantity', 'ReceivedTotalQuantity', 'ReceivedQty', 'CrossingUnits']
    const receivedAmountKeys = ['ReceivedTotalAmount', 'ReceivedAmount', 'ReceivedNetAmount', 'ReceivedTotalNetAmount', 'CrossingAmount']

    const grouped = rawTable.reduce((acc, row) => {
        const sourceBranch = firstValue(row, [
            'SourceBranchName',
            'SourceBranch',
            'BookBranchName',
            'BookingBranchName',
            'SourceBranchFilter',
            'SourceBranchNameFilter',
            'BranchName',
        ], 'NA')
        const destBranch = firstValue(row, [
            'DestinationBranchName',
            'DestinationBranch',
            'DestBranchName',
            'DestBranch',
            'ToBranchName',
            'DispatchedToBranchFilter',
            'SummaryToBranch',
            'Station',
        ], 'NA')
        const dispatchByBranch = firstValue(row, [
            'DispatchFromBranchFilter',
            'DispatchByBranch',
            'DispatchByBranchName',
            'FromBranchName',
            'SummaryFromBranch',
        ], selectedDispatchBranchName || 'NA')
        const paymentType = firstValue(row, ['PaymentType', 'PymtType', 'PaymentTypeName'], 'NA')
        const key = [sourceBranch, destBranch, dispatchByBranch, paymentType].join('::')

        if (!acc[key]) {
            acc[key] = {
                SourceBranch: sourceBranch,
                DestBranch: destBranch,
                DispatchByBranch: dispatchByBranch,
                PaymentType: paymentType,
                BookedLRCount: 0,
                BookedTotalUnits: 0,
                BookedTotalAmount: 0,
                ReceivedLRCount: 0,
                ReceivedTotalUnits: 0,
                ReceivedTotalAmount: 0,
            }
        }

        const units = Number(firstValue(row, ['Quantity', 'SummaryQuantity', 'TotalUnits'], 0)) || 0
        const amount = Number(firstValue(row, ['SummaryNetAmount', 'NetAmount', 'TotalNetAmount'], 0)) || 0
        const hasSummaryValues = [
            bookedLRKeys,
            bookedUnitKeys,
            bookedAmountKeys,
            receivedLRKeys,
            receivedUnitKeys,
            receivedAmountKeys,
        ].some((keys) => hasAnyValue(row, keys))

        if (hasSummaryValues) {
            acc[key].BookedLRCount += toNumber(firstValue(row, bookedLRKeys, 0))
            acc[key].BookedTotalUnits += toNumber(firstValue(row, bookedUnitKeys, 0))
            acc[key].BookedTotalAmount += toNumber(firstValue(row, bookedAmountKeys, 0))
            acc[key].ReceivedLRCount += toNumber(firstValue(row, receivedLRKeys, 0))
            acc[key].ReceivedTotalUnits += toNumber(firstValue(row, receivedUnitKeys, 0))
            acc[key].ReceivedTotalAmount += toNumber(firstValue(row, receivedAmountKeys, 0))
            return acc
        }

        const isBookedFromDispatchBranch =
            normalizeBranchName(sourceBranch) === normalizeBranchName(dispatchByBranch)

        if (isBookedFromDispatchBranch) {
            acc[key].BookedLRCount += 1
            acc[key].BookedTotalUnits += units
            acc[key].BookedTotalAmount += amount
        } else {
            acc[key].ReceivedLRCount += 1
            acc[key].ReceivedTotalUnits += units
            acc[key].ReceivedTotalAmount += amount
        }

        return acc
    }, {})

    const rowsByDispatchBranch = Object.values(grouped).reduce((acc, row) => {
        (acc[row.DispatchByBranch] ||= []).push(row)
        return acc
    }, {})

    const rows = []
    Object.entries(rowsByDispatchBranch).forEach(([dispatchByBranch, branchRows]) => {
        const serialMap = {}
        let serialNo = 0
        const totals = {
            BookedLRCount: 0,
            BookedTotalUnits: 0,
            BookedTotalAmount: 0,
            ReceivedLRCount: 0,
            ReceivedTotalUnits: 0,
            ReceivedTotalAmount: 0,
        }

        branchRows.forEach((row) => {
            const serialKey = [row.SourceBranch, row.DestBranch, row.DispatchByBranch].join('::')
            if (!serialMap[serialKey]) {
                serialNo += 1
                serialMap[serialKey] = serialNo
            }

            Object.keys(totals).forEach((field) => {
                totals[field] += Number(row[field]) || 0
            })

            rows.push({
                ...row,
                dataType: 'entry',
                SN: serialMap[serialKey],
                BookedTotalAmount: round(row.BookedTotalAmount),
                ReceivedTotalAmount: round(row.ReceivedTotalAmount),
            })
        })

        rows.push({
            dataType: 'total',
            colSpan: { SN: 5 },
            align: { SN: 'right' },
            SN: `TOTAL: ${dispatchByBranch}`,
            BookedLRCount: totals.BookedLRCount,
            BookedTotalUnits: totals.BookedTotalUnits,
            BookedTotalAmount: round(totals.BookedTotalAmount),
            ReceivedLRCount: totals.ReceivedLRCount,
            ReceivedTotalUnits: totals.ReceivedTotalUnits,
            ReceivedTotalAmount: round(totals.ReceivedTotalAmount),
        })
    })

    return [
        {
            dataType: 'header',
            colSpan: {
                SN: 1,
                SourceBranch: 1,
                DestBranch: 1,
                DispatchByBranch: 1,
                PaymentType: 1,
                BookedLRCount: 3,
                ReceivedLRCount: 3,
            },
            align: {
                SN: 'left',
                SourceBranch: 'left',
                DestBranch: 'left',
                DispatchByBranch: 'left',
                PaymentType: 'left',
                BookedLRCount: 'center',
                ReceivedLRCount: 'center',
            },
            SN: 'S/N',
            SourceBranch: 'Source Branch',
            DestBranch: 'Dest. Branch',
            DispatchByBranch: 'Dispatch By Branch',
            PaymentType: 'Pymt Type',
            BookedLRCount: 'Booked and Transfered/Dispatched.',
            ReceivedLRCount: 'Received and Transferred / Dispatched',
        },
        {
            dataType: 'header',
            colSpan: { SN: 1, SourceBranch: 1, DestBranch: 1, DispatchByBranch: 1, PaymentType: 1 },
            align: {
                SN: 'left',
                SourceBranch: 'left',
                DestBranch: 'left',
                DispatchByBranch: 'left',
                PaymentType: 'left',
                BookedLRCount: 'right',
                BookedTotalUnits: 'right',
                BookedTotalAmount: 'right',
                ReceivedLRCount: 'right',
                ReceivedTotalUnits: 'right',
                ReceivedTotalAmount: 'right',
            },
            SN: '',
            SourceBranch: '',
            DestBranch: '',
            DispatchByBranch: '',
            PaymentType: '',
            BookedLRCount: 'LR Count',
            BookedTotalUnits: 'Total Units',
            BookedTotalAmount: 'Total Amt.',
            ReceivedLRCount: 'LR Count',
            ReceivedTotalUnits: 'Total Units',
            ReceivedTotalAmount: 'Total Amt.',
        },
        ...rows,
    ]
}

export const buildBranchwiseSummaryCityMainHeader = () => {
    const textFields = ['SN', 'DispatchByBranch', 'DispatchDate']
    const columns = [
        { field: 'SN', header: 'SN', exportHead: 'SN', width: 60 },
        { field: 'DispatchByBranch', header: 'Dispatch By Branch', exportHead: 'Dispatch By Branch', width: 220 },
        { field: 'DispatchDate', header: 'Dispatch Date', exportHead: 'Dispatch Date', width: 150 },
        { field: 'Items', header: 'Total Units', exportHead: 'Total Units', width: 130 },
        { field: 'Freight', header: 'Freight', exportHead: 'Freight', width: 130 },
        { field: 'FreightKMS', header: 'Freight KMS', exportHead: 'Freight KMS', width: 130 },
        { field: 'Amount', header: 'Total Amount', exportHead: 'Total Amount', width: 150 },
    ]

    return columns.map((col) => ({
        ...col,
        align: textFields.includes(col.field) ? 'left' : 'right',
        xlCol: { dataType: textFields.includes(col.field) ? 'string' : 'number', dataFormatter: null },
        weight: 40,
        isSortIcon: col.field !== 'SN',
    }))
}

export const transformBranchwiseSummaryCity = (rawTable = []) => {
    const grouped = rawTable.reduce((acc, row) => {
        const city = firstValue(row, ['DispatchByCity', 'DispatchCity', 'CityName'], 'NA')
        ; (acc[city] ||= []).push(row)
        return acc
    }, {})

    const rows = []
    const grandTotal = { Items: 0, Freight: 0, FreightKMS: 0, Amount: 0 }
    let serialNo = 0

    Object.entries(grouped).forEach(([city, cityRows]) => {
        const cityTotal = { Items: 0, Freight: 0, FreightKMS: 0, Amount: 0 }

        rows.push({
            dataType: 'subHeader',
            colSpan: { SN: 7 },
            align: { SN: 'left' },
            SN: `Disp. From City: ${city}`,
        })

        cityRows.forEach((row) => {
            serialNo += 1

            const items = toNumber(row.Items)
            const freight = toNumber(row.Freight)
            const freightKMS = toNumber(row.FreightKMS)
            const amount = toNumber(row.Amount)

            cityTotal.Items += items
            cityTotal.Freight += freight
            cityTotal.FreightKMS += freightKMS
            cityTotal.Amount += amount

            rows.push({
                dataType: 'entry',
                SN: serialNo,
                DispatchByBranch: row.DispatchByBranch,
                DispatchDate: row.DispatchDate,
                Items: items,
                Freight: round(freight),
                FreightKMS: round(freightKMS),
                Amount: round(amount),
            })
        })

        Object.keys(grandTotal).forEach((field) => {
            grandTotal[field] += cityTotal[field]
        })

        rows.push({
            dataType: 'total',
            colSpan: { SN: 3 },
            align: { SN: 'right' },
            SN: `TOTAL: Disp. From City: ${city}`,
            Items: cityTotal.Items,
            Freight: round(cityTotal.Freight),
            FreightKMS: round(cityTotal.FreightKMS),
            Amount: round(cityTotal.Amount),
        })
    })

    rows.push({
        dataType: 'total',
        colSpan: { SN: 3 },
        align: { SN: 'right' },
        SN: 'TOTAL: Disp. From City: All Cities',
        Items: grandTotal.Items,
        Freight: round(grandTotal.Freight),
        FreightKMS: round(grandTotal.FreightKMS),
        Amount: round(grandTotal.Amount),
    })

    return rows
}

export const buildTripCitywiseDispatchMainHeader = (destinationCities = []) => {
    const cityColumns = destinationCities.flatMap((city, index) => ([
        {
            field: `city_${index}_units`,
            header: 'Units',
            exportHead: `${city} Units`,
            align: 'right',
            width: 80,
            weight: 70,
            xlCol: { dataType: 'number', dataFormatter: null },
            isSortIcon: false,
        },
        {
            field: `city_${index}_amount`,
            header: 'Amount',
            exportHead: `${city} Amount`,
            align: 'right',
            width: 90,
            weight: 80,
            xlCol: { dataType: 'number', dataFormatter: null },
            isSortIcon: false,
        },
    ]))

    return [
        {
            field: 'DispatchFromCity',
            header: 'Dispatch From City',
            exportHead: 'Dispatch From City',
            align: 'left',
            width: 240,
            weight: 220,
            xlCol: { dataType: 'string', dataFormatter: null },
            isSortIcon: false,
        },
        ...cityColumns,
        {
            field: 'TotalUnits',
            header: 'Units',
            exportHead: 'Total Units',
            align: 'right',
            width: 80,
            weight: 70,
            xlCol: { dataType: 'number', dataFormatter: null },
            isSortIcon: false,
        },
        {
            field: 'TotalAmount',
            header: 'Amount',
            exportHead: 'Total Amount',
            align: 'right',
            width: 90,
            weight: 80,
            xlCol: { dataType: 'number', dataFormatter: null },
            isSortIcon: false,
        },
    ]
}

export const transformTripCitywiseDispatch = (rawTable = []) => {
    const getDestinationCity = (row) => firstValue(row, [
        'ToCityName',
        'DispatchedToCityFilter',
        'DispatchedToCity',
        'DispatchToCity',
        'DestinationCity',
        'Station',
        'ToCity',
    ], 'NA')

    const groupedByTrip = rawTable.reduce((acc, row) => {
        const tripId = toNumber(firstValue(row, ['TripId', 'TripID', 'UniqueTripIDs'], 0))
        const tripName = firstValue(row, ['TripName', 'UniqueTripNames', 'Trip', 'RouteName'], 'NA')
        const chartDate = firstValue(row, ['ChartDate', 'TripDateTime', 'DispatchDateTime', 'DispatchDate'], '')
        const vehicleNo = firstValue(row, ['VehicleNo', 'VehicleNoFilter', 'BusNumber', 'VehicleNumber'], '')
        const key = tripId > 0 ? `trip_${tripId}` : `vehicle_${vehicleNo || 'NA'}`

        if (!acc[key]) {
            acc[key] = { tripId, tripName, chartDate, vehicleNo, rows: [] }
        }

        acc[key].rows.push(row)
        return acc
    }, {})

    const groupedTrips = Object.values(groupedByTrip).map((trip) => ({
        ...trip,
        destinationCities: [...new Set(trip.rows.map(getDestinationCity))],
    })).sort((a, b) => {
        const aDate = moment(a.chartDate, ['YYYY-MM-DD', 'DD-MM-YYYY', 'DD-MMM-YYYY', moment.ISO_8601], true)
        const bDate = moment(b.chartDate, ['YYYY-MM-DD', 'DD-MM-YYYY', 'DD-MMM-YYYY', moment.ISO_8601], true)

        if (aDate.isValid() && bDate.isValid()) return aDate.valueOf() - bDate.valueOf()
        if (aDate.isValid()) return -1
        if (bDate.isValid()) return 1
        return String(a.chartDate).localeCompare(String(b.chartDate))
    })
    const tables = []
    groupedTrips.forEach((trip) => {
        const mainHeader = buildTripCitywiseDispatchMainHeader(trip.destinationCities)
        const allColumnCount = mainHeader.length
        const cityIndexMap = Object.fromEntries(trip.destinationCities.map((city, index) => [city, index]))
        const tableData = []
        const fromCityRows = trip.rows.reduce((acc, row) => {
            const fromCity = firstValue(row, [
                'FromCityName',
                'SummaryFromCity',
                'DispatchFromCity',
                'DispatchFromCityFilter',
                'BookCity',
                'FromCity',
            ], 'NA')

            if (!acc[fromCity]) acc[fromCity] = []
            acc[fromCity].push(row)
            return acc
        }, {})

        tableData.push({
            dataType: 'subHeader',
            colSpan: { DispatchFromCity: allColumnCount },
            align: { DispatchFromCity: 'left' },
            rowStyle: { backgroundColor: '#b7c8e6' },
            DispatchFromCity: `Trip Name: ${trip.tripName} | Trip Date-Time: ${trip.chartDate} | Vehicle: ${trip.vehicleNo || 'NA'}`,
        })

        const dispatchToRow = {
            dataType: 'subHeader',
            colSpan: { DispatchFromCity: 1 },
            align: { DispatchFromCity: 'left' },
            DispatchFromCity: 'Dispatch To Cities >',
        }

        trip.destinationCities.forEach((city, index) => {
            dispatchToRow[`city_${index}_units`] = city
            dispatchToRow.colSpan[`city_${index}_units`] = 2
            dispatchToRow.align[`city_${index}_units`] = 'center'
        })
        dispatchToRow.TotalUnits = 'Total'
        dispatchToRow.colSpan.TotalUnits = 2
        dispatchToRow.align.TotalUnits = 'center'
        tableData.push(dispatchToRow)

        const measureHeaderRow = {
            dataType: 'subHeader',
            align: { DispatchFromCity: 'left' },
            DispatchFromCity: 'Dispatch From City',
        }

        trip.destinationCities.forEach((city, index) => {
            measureHeaderRow[`city_${index}_units`] = 'Units'
            measureHeaderRow[`city_${index}_amount`] = 'Amount'
            measureHeaderRow.align[`city_${index}_units`] = 'center'
            measureHeaderRow.align[`city_${index}_amount`] = 'center'
        })
        measureHeaderRow.TotalUnits = 'Units'
        measureHeaderRow.TotalAmount = 'Amount'
        measureHeaderRow.align.TotalUnits = 'center'
        measureHeaderRow.align.TotalAmount = 'center'
        tableData.push(measureHeaderRow)

        const tripTotal = { TotalUnits: 0, TotalAmount: 0 }
        trip.destinationCities.forEach((city, index) => {
            tripTotal[`city_${index}_units`] = 0
            tripTotal[`city_${index}_amount`] = 0
        })

        Object.entries(fromCityRows).forEach(([fromCity, rows]) => {
            const cityTotals = {}
            trip.destinationCities.forEach((city, index) => {
                cityTotals[`city_${index}_units`] = 0
                cityTotals[`city_${index}_amount`] = 0
            })

            rows.forEach((row) => {
                const toCity = getDestinationCity(row)
                const cityIndex = cityIndexMap[toCity]
                const units = toNumber(firstValue(row, ['TotalUnits', 'Quantity', 'NOP', 'Items', 'Unit', 'Units'], 0))
                const amount = toNumber(firstValue(row, ['TotalNetAmount', 'NetAmount', 'Amount', 'FreightKMS', 'Freight'], 0))

                cityTotals[`city_${cityIndex}_units`] += units
                cityTotals[`city_${cityIndex}_amount`] += amount
                tripTotal[`city_${cityIndex}_units`] += units
                tripTotal[`city_${cityIndex}_amount`] += amount
                tripTotal.TotalUnits += units
                tripTotal.TotalAmount += amount
            })

            const totalUnits = trip.destinationCities.reduce((sum, city, index) => sum + cityTotals[`city_${index}_units`], 0)
            const totalAmount = trip.destinationCities.reduce((sum, city, index) => sum + cityTotals[`city_${index}_amount`], 0)

            tableData.push({
                dataType: 'entry',
                DispatchFromCity: fromCity,
                ...Object.fromEntries(Object.entries(cityTotals).map(([key, value]) => [key, round(value)])),
                TotalUnits: round(totalUnits),
                TotalAmount: round(totalAmount),
            })
        })

        tableData.push({
            dataType: 'total',
            align: { DispatchFromCity: 'left' },
            DispatchFromCity: `Total Vehicle: ${trip.vehicleNo || 'NA'}`,
            ...Object.fromEntries(Object.entries(tripTotal).map(([key, value]) => [key, round(value)])),
        })

        tables.push({
            mainHeader,
            tableData,
            enableHorizontalScroll: true,
        })
    })

    const commonTableWidth = `${Math.max(520, ...tables.map((table) => table.mainHeader.length * 90))}px`
    const sameWidthTables = tables.map((table) => ({
        ...table,
        minTableWidth: commonTableWidth,
    }))

    return {
        mainHeader: sameWidthTables[0]?.mainHeader || buildTripCitywiseDispatchMainHeader([]),
        tableData: sameWidthTables.flatMap((table) => table.tableData),
        tables: sameWidthTables,
    }
}

export const transformHamaliAndCartage = (rawTable) => {
    const updatedData = rawTable.map((val, i) => ({
        ...val,
        SN: i + 1,
        HamaliTotal: val.DDDVHamali + val.FocAndSelfHamali + val.OnAccountHamali + val.PaidHamali + val.TopayHamali,
        CartageTotal: val.DDDVCartage + val.FocAndSelfCartage + val.OnAccountCartage + val.PaidCartage + val.TopayCartage,
        GstTotal: val.DDDVGST + val.FocAndSelfGST + val.OnAccountGST + val.PaidGST + val.TopayGST,
        ValuationTotal: val.DDDVInsurance + val.FocAndSelfInsurance + val.OnAccountInsurance + val.PaidInsurance + val.TopayInsurance,
        OtherChargeTotal: val.DDDVOther + val.FocAndSelfOther + val.OnAccountOther + val.PaidOther + val.TopayOther,
    }))

    const withNetOther = updatedData.map((val) => ({
        ...val,
        OtherChargeTotal: val.OtherChargeTotal - val.HamaliTotal - val.CartageTotal - val.GstTotal - val.ValuationTotal,
    }))

    let unitTotal = 0, lrs = 0, freight = 0, paid = 0, topay = 0,
        onAct = 0, foc = 0, dddv = 0, hamali = 0, cartage = 0,
        gst = 0, val_ = 0, other = 0, net = 0

    const formatted = withNetOther.map((val) => {
        unitTotal += Number(val.TotalUnits); lrs += Number(val.TotalLRCount)
        freight += Number(val.TotalFreight); topay += Number(val.TopayFreight)
        paid += Number(val.PaidFreight); onAct += Number(val.OnAccountFreight)
        foc += Number(val.FocAndSelfFreight); dddv += Number(val.DDDVFreight)
        hamali += Number(val.HamaliTotal); cartage += Number(val.CartageTotal)
        gst += Number(val.GstTotal); val_ += Number(val.ValuationTotal)
        other += Number(val.OtherChargeTotal); net += Number(val.TotalNetAmount)
        return {
            ...val,
            dataType: 'entry',
            'DriverConductorName^^ContactNo': `${val.DriverConductorName}\n${val.ContactNo}`,
            TotalUnits: Number(val.TotalUnits),
            TotalLRCount: Number(val.TotalLRCount),
            TotalFreight: Number(val.TotalFreight),
            TopayFreight: Number(val.TopayFreight),
            PaidFreight: Number(val.PaidFreight),
            OnAccountFreight: Number(val.OnAccountFreight),
            FocAndSelfFreight: Number(val.FocAndSelfFreight),
            DDDVFreight: Number(val.DDDVFreight),
            HamaliTotal: Number(val.HamaliTotal),
            CartageTotal: Number(val.CartageTotal),
            GstTotal: Number(val.GstTotal),
            ValuationTotal: Number(val.ValuationTotal),
            OtherChargeTotal: round(Number(val.OtherChargeTotal)),
            TotalNetAmount: Number(val.TotalNetAmount),
        }
    })

    formatted.push({
        dataType: 'total',
        colSpan: { SN: 4 },
        SN: 'TOTAL AMOUNT',
        TotalUnits: unitTotal,
        TotalLRCount: lrs,
        TotalFreight: freight,
        TopayFreight: topay,
        PaidFreight: paid,
        OnAccountFreight: onAct,
        FocAndSelfFreight: foc,
        DDDVFreight: dddv,
        HamaliTotal: hamali,
        CartageTotal: cartage,
        GstTotal: gst,
        ValuationTotal: val_,
        OtherChargeTotal: round(other),
        TotalNetAmount: round(net),
    })
    return formatted
}

export const transformBranchSummary = (rawTable) => transformHamaliAndCartage(rawTable)

export const transformWithOtherCharges = (rawTable) => {
    const step1 = rawTable.map((val) => ({
        ...val,
        'BusNumber^^SealNo': val.BusNumber + (val.SealNo ? '\n' + val.SealNo : ''),
        'DriverConductorName^^ContactNo': `${val.DriverConductorName}\n${val.ContactNo}`,
        'ToCityName^^ToBranchName': `${val.ToCityName}\n${val.ToBranchName}`,
        TopayCodGstOth: val.TopayGST + val.TopayOther,
        PaidGstOth: val.PaidGST + val.PaidOther,
        OnActGstOth: val.OnAccountGST + val.OnAccountOther,
        FOCSelfGstOth: val.FocAndSelfGST + val.FocAndSelfOther,
        DDDVGstOth: val.DDDVGST + val.DDDVOther,
        OtherCharge: val.TopayOther + val.PaidOther + val.OnAccountOther + val.FocAndSelfOther + val.DDDVOther,
    }))

    const step2 = step1.map((val) => ({
        ...val,
        NetOther: val.TopayCodGstOth + val.PaidGstOth + val.OnActGstOth + val.FOCSelfGstOth + val.DDDVGstOth - val.Insurance,
        dataType: 'entry',
    }))

    let topayCodU = 0, paidU = 0, onActU = 0, focU = 0, dddvU = 0, netU = 0,
        topayF = 0, paidF = 0, onActF = 0, focF = 0, dddvF = 0, totalF = 0,
        topayG = 0, paidG = 0, onActG = 0, focG = 0, dddvG = 0, netG = 0,
        valuation = 0, other = 0, lrs = 0, net = 0

    step2.forEach((val) => {
        topayCodU += Number(val.TopayUnit); paidU += Number(val.PaidUnit)
        onActU += Number(val.OnAccountUnit); focU += Number(val.FocAndSelfUnit)
        dddvU += Number(val.DDDVUnit); netU += Number(val.TotalUnits)
        topayF += Number(val.TopayFreight); paidF += Number(val.PaidFreight)
        onActF += Number(val.OnAccountFreight); focF += Number(val.FocAndSelfFreight)
        dddvF += Number(val.DDDVFreight); totalF += Number(val.TotalFreight)
        topayG += Number(val.TopayCodGstOth);
        // paidG += Number(val.PaidGstOth)
        paidG = Number((paidG + Number(val.PaidGstOth)).toFixed(2))
        onActG += Number(val.OnActGstOth); focG += Number(val.FOCSelfGstOth)
        dddvG += Number(val.DDDVGstOth); netG += Number(val.NetOther)
        valuation += Number(val.Insurance); other += Number(val.OtherCharge)
        lrs += Number(val.TotalLRCount); net += Number(val.TotalNetAmount)
    })

    step2.push({
        dataType: 'total',
        colSpan: { 'BusNumber^^SealNo': 3 },
        align: { 'BusNumber^^SealNo': 'right' },
        'BusNumber^^SealNo': 'TOTAL AMOUNT',
        BusNumber: 'TOTAL AMOUNT',
        SealNo: '',
        TopayUnit: topayCodU, PaidUnit: paidU,
        OnAccountUnit: onActU, FocAndSelfUnit: focU,
        DDDVUnit: dddvU, TotalUnits: netU,
        TopayFreight: topayF, PaidFreight: paidF,
        OnAccountFreight: onActF, FocAndSelfFreight: focF,
        DDDVFreight: dddvF, TotalFreight: totalF,
        TopayCodGstOth: topayG, PaidGstOth: paidG,
        OnActGstOth: onActG, FOCSelfGstOth: focG,
        DDDVGstOth: dddvG, NetOther: round(netG),
        Insurance: valuation, OtherCharge: round(other),
        TotalLRCount: lrs, TotalNetAmount: round(net),
    })

    return step2
}

export const transformVehicleWiseDispatch = (rawTable) => {
    const data = rawTable.map((val, index) => ({
        ...val,
        dataType: 'entry',
        SN: index + 1,
        'BusNumber^^SealNo': val.BusNumber + (val.SealNo ? '\n' + val.SealNo : ''),
        'FromCityName^^FromBranchName': val.FromBranchName + '\n' + val.FromCityName,
        'ToCityName^^ToBranchName': val.ToCityName + '\n' + val.ToBranchName,
        DispatchDateTime: val.DispatchDateTime || '',
        'DriverConductorName^^ContactNo': val.DriverConductorName + '\n' + val.ContactNo,
    }))

    let paidU = 0, topayU = 0, onActU = 0, focU = 0, totalU = 0,
        paidA = 0, topayA = 0, onActA = 0, focA = 0, totalA = 0

    data.forEach((val) => {
        paidU += Number(val.PaidUnit); topayU += Number(val.TopayUnit)
        onActU += Number(val.OnAccountUnit); focU += Number(val.FocAndSelfUnit)
        totalU += Number(val.TotalUnits); paidA += Number(val.PaidTotal)
        topayA += Number(val.ToPayTotal); onActA += Number(val.OnAccountTotal)
        focA += Number(val.FOCTotal); totalA += Number(val.TotalNetAmount)
    })

    data.push({
        dataType: 'total',
        colSpan: { SN: 6 },
        align: { SN: 'right' },
        SN: 'TOTAL',
        PaidUnit: paidU, TopayUnit: topayU,
        OnAccountUnit: onActU, FocAndSelfUnit: focU,
        TotalUnits: totalU, PaidTotal: round(paidA),
        ToPayTotal: topayA, OnAccountTotal: onActA,
        FOCTotal: focA, TotalNetAmount: round(totalA),
    })
    return data
}

export const transformOtherCharges = (rawTable) => {
    const step1 = rawTable.map((val, index) => ({
        ...val,
        dataType: 'entry',
        srNo: index + 1,
        TotalPaid: val.PaidFreight + val.PaidOther + val.PaidGST,
        TotalToPay: val.TopayFreight + val.TopayOther + val.TopayGST,
        TotalToPayDDDV: val.DDDVFreight + val.DDDVOther + val.DDDVGST,
        NetAmount: val.TotalNetAmount,
        TotalOnAcc: val.OnAccountFreight + val.OnAccountOther + val.OnAccountGST,
    }))

    let units = 0, paidF = 0, topayF = 0, dddvF = 0, onAccF = 0,
        paidO = 0, topayO = 0, dddvO = 0, onAccO = 0,
        paidG = 0, topayG = 0, dddvG = 0, onAccG = 0,
        paid = 0, topay = 0, dddv = 0, onAcc = 0, net = 0

    step1.forEach((val) => {
        units += Number(val.TotalUnits); paidF += Number(val.PaidFreight)
        topayF += Number(val.TopayFreight); dddvF += Number(val.DDDVFreight)
        paidO += Number(val.PaidOther); topayO += Number(val.TopayOther)
        dddvO += Number(val.DDDVOther); paidG += Number(val.PaidGST)
        topayG += Number(val.TopayGST); dddvG += Number(val.DDDVGST)
        paid += Number(val.TotalPaid); topay += Number(val.TotalToPay)
        dddv += Number(val.TotalToPayDDDV); net += Number(val.NetAmount)
        onAccF += Number(val.OnAccountFreight)
        onAccO += Number(val.OnAccountOther)
        onAccG += Number(val.OnAccountGST)
        onAcc += Number(val.TotalOnAcc)
    })

    step1.push({
        dataType: 'total',
        colSpan: { srNo: 6 },
        srNo: 'TOTAL AMOUNT',
        TotalUnits: units, PaidFreight: paidF,
        TopayFreight: topayF, DDDVFreight: dddvF, OnAccountFreight: onAccF,
        PaidOther: round(paidO), TopayOther: topayO,
        DDDVOther: dddvO, OnAccountOther: onAccO, PaidGST: paidG,
        TopayGST: topayG, DDDVGST: dddvG, OnAccountGST: onAccG,
        TotalPaid: round(paid), TotalToPay: topay,
        TotalToPayDDDV: dddv, TotalOnAcc: onAcc, NetAmount: round(net),
    })
    return step1
}

export const openReportInNewTab = (reportPayload) => {
    const rid = Date.now().toString()
    if (!window.generatedReports) window.generatedReports = {}
    window.generatedReports[rid] = reportPayload
    window.open(`/view-report?rid=${rid}`, '_blank')
}
